import styled from '@emotion/styled';

import Box from 'shared/Box';
import { Caret } from 'shared/Caret';

export const SettingsMenuBox = styled.div`
  display: flex;
  align-items: center;
  height: 46px;
`;

export const StyledCoverArtBox = styled(Box)`
  border-radius: 2px;
`;

export const StyledSettingsSpan = styled.span`
  color: rgba(255, 255, 255, 0.8);
  font-weight: bold;
  font-size: 16px;
  line-height: 1.25;
  &:hover {
    color: #fff;
  }
`;

export const StyledCaret = styled(Caret)`
  border-top-color: rgba(255, 255, 255, 0.8);
  &:hover {
    border-top-color: #fff;

    div {
      border-top-color: #fff;
    }
  }
`;
